module.exports = __webpack_public_path__ + "videos/ada-cube.9ba0172.mp4";